import { useId } from 'react';
import { ArrowRight } from 'lucide-react';
import { PARTNERS_APPLY_URL, PARTNERS_URL } from '@/lib/partnerLinks';
import styles from './InstallerBand.module.css';

/** The band's primary button, also the call to action on the electrician
 *  /why page (Warren, 9 Oct 2026). */
export function BecomePartnerButton({ className }: { className?: string }) {
  return (
    <a className={className ? `${styles.primary} ${className}` : styles.primary} href={PARTNERS_APPLY_URL}>
      Become a Sales Partner
    </a>
  );
}

/** The installer band (Warren, 8 Oct 2026): full width, directly above the
 *  shop footer on every page, and a second time on /commercial-dc where
 *  installers are the main buyers. It replaced a small footer card that got
 *  missed. The copy is Warren's, word for word: no other earnings claims. */
export function InstallerBand({ className }: { className?: string }) {
  const headingId = useId();
  return (
    <section
      className={className ? `${styles.band} ${className}` : styles.band}
      aria-labelledby={headingId}
    >
      <div className={styles.inner}>
        <div>
          <p className={styles.kicker}>For electricians and installers</p>
          <h2 id={headingId} className={styles.headline}>
            Sell it. Install it. Earn on it for as long as it runs.
          </h2>
          <p className={styles.body}>
            Buy at MSRP and keep your install margin. At the pay-to-use sites you bring us, you
            also earn 2 to 3 points of our 15-point platform share on every paid session. A person
            reviews every application and replies within one business day.
          </p>
        </div>
        <div className={styles.actions}>
          <BecomePartnerButton />
          <a className={styles.secondary} href={PARTNERS_URL}>
            How the program works <ArrowRight size={16} aria-hidden />
          </a>
        </div>
      </div>
    </section>
  );
}
